import React from "react";
import { TableAction } from "../../utils/tableActions";
import TableHeader from "./TableHeader";
import TableRow from "./TableRow";
import EmptyState from "./EmptyState";

interface TableProps {
  headers: string[];
  data: (string | React.ReactNode)[][];
  actions?: TableAction[];
  actionsColumnTitle?: string;
}

const Table = ({
  headers,
  data,
  actions,
  actionsColumnTitle = "Ações",
}: TableProps) => {
  const hasActions = actions && actions.length > 0;

  if (data.length === 0) {
    return (
      <div className="mt-10 overflow-x-auto rounded-lg bg-white shadow">
        <table className="min-w-full divide-y divide-neutral-200">
          <TableHeader
            headers={headers}
            hasActions={hasActions}
            actionsColumnTitle={actionsColumnTitle}
          />
        </table>
        <EmptyState />
      </div>
    );
  }

  return (
    <div className="mt-10 overflow-x-auto rounded-lg bg-white shadow">
      <table className="min-w-full divide-y divide-neutral-200">
        <TableHeader
          headers={headers}
          hasActions={hasActions}
          actionsColumnTitle={actionsColumnTitle}
        />
        <tbody className="divide-y divide-neutral-200 bg-white">
          {data.map((row, rowIndex) => (
            <TableRow
              key={rowIndex}
              row={row}
              rowIndex={rowIndex}
              actions={actions}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
